import React, { useState } from 'react';
import Sidebar from '../Components/DashboardComponents/sidebar';
import DashboardComponent from '../Components/DashboardComponents/dashboard';
import Map from '../Components/DashboardComponents/map';
import Reports from '../Components/DashboardComponents/report';
import AnalysisComponent from '../Components/DashboardComponents/analysis';
import Register from '../Components/DashboardComponents/register'; // ✅ NEW

const Dashboard = () => {
  const [selectedContent, setSelectedContent] = useState('Dashboard');

  const handleSelectContent = (content) => {
    setSelectedContent(content);
  };

  const renderContent = () => {
    switch (selectedContent) {
      case 'Dashboard':
        return <DashboardComponent />;
      case 'Map':
        return <Map />;
      case 'Register': // ✅ NEW
        return <Register />;
      case 'Analysis':
        return <AnalysisComponent />;
      case 'Reports':
        return <Reports />;
      default:
        return <DashboardComponent />;
    }
  };

  return (
    <div style={styles.dashboardContainer}>
      <Sidebar onSelect={handleSelectContent}  />
      <div style={{ ...styles.content}}>
        <div style={styles.mainContent}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

const styles = {
  dashboardContainer: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  mainContent: {
    flexGrow: 1,
    backgroundColor: '#f4f7f9',
    overflowY: 'auto',
    padding: '20px',
    position: 'relative',
  },
};

export default Dashboard;